export default {
  // 报料详情接口
  getDiscloseMaterialInfo: '/amc/client/getDiscloseMaterialInfo',
  // 查询报料频道
  listDiscloseChannelByCategoryCode: '/amc/client/listDiscloseChannelByCategoryCode',
  // 获取频道下报料列表
  listDiscloseMaterialByPublish: '/amc/client/listDiscloseMaterialByPublish',
  // 获取我的报料列表
  listDiscloseMaterialByMemberId: '/amc/client/listDiscloseMaterialByMemberId',
  // 添加报料
  addDiscloseMaterial: '/amc/client/addDiscloseMaterial',
}